// invitation.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { acceptInvitationSuccess } from './invitation.actions';

export interface InvitationState {
  loading: boolean;
  error: unknown | null;
}

export const initialState: InvitationState = {
  loading: false,
  error: null,
};

export const invitationReducer = createReducer(
  initialState,
  on(acceptInvitationSuccess, (state, { payload }) => ({
    ...state,
    acceptResponse: payload,
    loading: false,
  })),
);
